import React, { useState, useEffect } from 'react';
import ErrorPage from '../errorPage/ErrorPage';
import Card from './Card';
import InputForm from './InputForm';
import axios from 'axios';

const Cards = () => {
  const [contests, setContests] = useState([]);
  const [query, setQuery] = useState('all');
  const [error, setError] = useState(false);

  const url = `https://kontests.net/api/v1/${query}`;

  useEffect(() => {
    getContests();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  const getContests = async () => {
    try {
      const response = await axios.get(url);
      setContests(response.data);
    } catch (error) {
      setError(true);
      console.error(error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError(false);
    const toSearch = e.target[0].value.toLowerCase();
    if (toSearch === 'topcoder') {
      setQuery('top_coder');
    } else if (toSearch === 'atcoder') {
      setQuery('at_coder');
    } else if (toSearch === 'codechef') {
      setQuery('code_chef');
    } else if (toSearch === 'hackerrank') {
      setQuery('hacker_rank');
    } else if (toSearch === 'hackerearth') {
      setQuery('hacker_earth');
    } else if (toSearch === 'kickstart') {
      setQuery('kick_start');
    } else if (toSearch === 'leetcode') {
      setQuery('leet_code');
    } else {
      setQuery(toSearch);
    }
  };

  return (
    <section id='contests' className=''>
      <InputForm handleSubmit={handleSubmit} />

      {error ? (
        <ErrorPage />
      ) : (
        <>
          <div className='row contests'>
            {contests.map((contest, index) => (
              <Card contest={contest} query={query} key={index} />
            ))}
          </div>
        </>
      )}
    </section>
  );
};

export default Cards;
